module.exports = __webpack_public_path__ + "static/media/brand-logo-black.92e7dca0.svg";